import {
    useSnackbar, useTranslation, useJson,
} from '@/composables';

type ClipboardOptionsType = {
    successMessage?: string;
    errorMessage?: string;
    formatAsJson?: boolean;
};

export const useClipboard = () => {
    const { showSnackbar } = useSnackbar();
    const { t } = useTranslation();
    const { formatJsonForDisplay } = useJson();

    const copyToClipboard = async (data: unknown, options: ClipboardOptionsType = {}): Promise<boolean> => {
        const {
            successMessage = t('messages.copiedToClipboard'),
            errorMessage = t('messages.copyFailed'),
            formatAsJson = true,
        } = options;

        try {
            let textToCopy: string;

            if (formatAsJson) {
                if (typeof data === 'string') {
                    textToCopy = data;
                } else {
                    textToCopy = formatJsonForDisplay(data);
                }
            } else {
                textToCopy = String(data);
            }

            await navigator.clipboard.writeText(textToCopy);
            showSnackbar(successMessage);

            return true;
        } catch (error) {
            console.error('Failed to copy to clipboard:', error);
            showSnackbar(errorMessage);

            return false;
        }
    };

    return { copyToClipboard };
};
